import { render, staticRenderFns } from "./LineIcon.vue?vue&type=template&id=2f6ca84e&scoped=true"
import script from "./LineIcon.vue?vue&type=script&lang=js"
export * from "./LineIcon.vue?vue&type=script&lang=js"
import style0 from "./LineIcon.vue?vue&type=style&index=0&id=2f6ca84e&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6ca84e",
  null
  
)

export default component.exports